// Author YuJiaBei
// create by manual
// Date 2020-05-14 14:52:02

class RepairWorkOrderExecute {
    constructor({
                    id = null,
                    actualStartTime = '',
                    actualFinishTime = '',
                    participantEmployeeCodes = ''
                }
                    = {}) {
        this.id = id;
        this.actualStartTime = actualStartTime;
        this.actualFinishTime = actualFinishTime;
        this.participantEmployeeCodes = participantEmployeeCodes;
    }
}

function newEntity() {
    return new RepairWorkOrderExecute();
}

const filter = {
    participantEmployeeCodeFilter : ""
};
const entityFormConfigs = [
    {
        key: 'actualStartTime',
        label: 'label.em.repair.repairWorkOrderExecute.entity.actualStartTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker'
            , required: true
        }
    },
    {
        key: 'actualFinishTime',
        label: 'label.em.repair.repairWorkOrderExecute.entity.actualFinishTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker'
            , required: true
        }
    },
    {
        key: 'participantEmployeeCodes',
        label: 'label.em.repair.repairWorkOrderExecute.entity.participantEmployeeCodes',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea'
            , required: false
        }
    }
]

export {RepairWorkOrderExecute, newEntity, filter,entityFormConfigs}
